import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Cv () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.cardiovascularRhythm.name}
            options={[
              {
                label: 'Regular Rhythm',
                value: 'Regular Rhythm'
              },
              {
                label: 'Irregular Rhythm',
                value: 'Irregular Rhythm'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.cardiovascularRate.name}
            options={[
              {
                label: 'Normal Rate',
                value: 'Normal Rate'
              },
              {
                label: 'Tachycardia',
                value: 'Tachycardia'
              },
              {
                label: 'Bradycardia',
                value: 'Bradycardia'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={
              PEQuestionnaire.cardiovascularNormalSoundANDabnormalSound.name
            }
            options={[
              {
                label: 'Normal Heart Valve Sounds',
                value: 'Normal Heart Valve Sounds'
              },
              {
                label: 'Abnormal Heart Valve Sounds',
                value: 'Abnormal Heart Valve Sounds'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.cardiovascularMurmur.name}
            options={[
              {
                label: 'No Murmur',
                value: 'No Murmur'
              },
              {
                label: 'Murmur',
                value: 'Murmur'
              }
            ]}
          />
        </div>
        <div className='col-xs-offset-1 col-xs-11 margin-top'>
          <CheckboxInput {...PEQuestionnaire.cardiovascularOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.cardiovascularOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Cv
